import { render, staticRenderFns } from "./_collection.vue?vue&type=template&id=4ba6050b&scoped=true&lang=pug&"
import script from "./_collection.vue?vue&type=script&lang=coffee&"
export * from "./_collection.vue?vue&type=script&lang=coffee&"
import style0 from "./_collection.vue?vue&type=style&index=0&id=4ba6050b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba6050b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksList: require('/opt/build/repo/nuxt-app/components/globals/blocks/list.vue').default,PlpProductFilter: require('/opt/build/repo/nuxt-app/components/pages/plp/product-filter.vue').default,BlocksSimpleMarquee: require('/opt/build/repo/nuxt-app/components/blocks/simple-marquee.vue').default})
